const filterLegsByProductRefs = (legs, productRefs) =>
  legs.filter((leg) => (leg.bookingItems || leg.products).some(({ itemRef }) => productRefs.includes(itemRef)));

export default filterLegsByProductRefs;
